export default "__VITE_ASSET__szR8gV5u__"